var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header-container"},[_c('div',{staticClass:"corporation-selector"},[_c('corporation-selector')],1),_c('div',[_c('user-info')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }